import { render, staticRenderFns } from "./AssetsTableCell.vue?vue&type=template&id=c10a03d6&scoped=true"
import script from "./AssetsTableCell.vue?vue&type=script&lang=js"
export * from "./AssetsTableCell.vue?vue&type=script&lang=js"
import style0 from "./AssetsTableCell.vue?vue&type=style&index=0&id=c10a03d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10a03d6",
  null
  
)

export default component.exports